// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3616226c","239":"7ab30925","271":"3c9b650b","279":"744e0ee8","453":"0b0d310b","455":"8bde2e45","595":"9805dad1","656":"51db0fc7"}[chunkId] + ".chunk.js";
};